// "Revenue information" card of a charter request: the request's own revenue calculation.
import { Card, Descriptions, Typography } from 'antd';

import type { CharterRequestDetail } from '../../api/types';
import { commissionLabel, gbp } from '../../data/format';

const { Text } = Typography;

export function RevenueCard({
  revenue,
}: {
  revenue: NonNullable<CharterRequestDetail['revenue']>;
}) {
  return (
    <Card title="Revenue information">
      <Descriptions bordered column={{ xs: 1, sm: 2 }} size="small">
        <Descriptions.Item label="Aircraft MGAV">{gbp(revenue.aircraftMgavGbp)}</Descriptions.Item>
        <Descriptions.Item label="Operator revenue">{gbp(revenue.operatorRevenueGbp)}</Descriptions.Item>
        <Descriptions.Item label={commissionLabel(revenue.processingFeePct)}>
          {gbp(revenue.processingCommissionGbp)}
        </Descriptions.Item>
        <Descriptions.Item label="ShareJet margin">{gbp(revenue.shareJetMarginGbp)}</Descriptions.Item>
        <Descriptions.Item label="Total revenue">
          <Text strong>{gbp(revenue.totalRevenueGbp)}</Text>
        </Descriptions.Item>
        {/* SHAR-995 (Copilot review) — revenue and what the customer paid are
            two different numbers: the fixed fee is inside the charge and is
            not revenue, so the card shows both rather than one figure that
            does not add up against the rows above it. Only shown when it
            differs, so a request without a fee reads as before. */}
        {/* SHAR-1374 — the fixed fee itself is shown too, so the admin sees what the user paid. */}
        {revenue.fixedFeeGbp != null && (
          <Descriptions.Item label="Fixed fee">{gbp(revenue.fixedFeeGbp)}</Descriptions.Item>
        )}
        {revenue.customerTotalGbp != null &&
          revenue.customerTotalGbp !== revenue.totalRevenueGbp && (
            <Descriptions.Item label="Customer total (incl. fixed fee)">
              {gbp(revenue.customerTotalGbp)}
            </Descriptions.Item>
          )}
        <Descriptions.Item label="Based on">
          {revenue.source === 'request'
            ? 'Original request'
            : 'Original request (recalculated with current settings)'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
